'use strict';

const React = require('react'),
    {t} = require('services/i18nextWrapper'),
    AdminScaffolding = require('components/Commons/AdminScaffolding/AdminScaffolding'),
    Loading = require('components/Commons/Loading/Loading'),
    AdminScaffoldingTable = require('components/Commons/AdminScaffolding/AdminScaffoldingTable/AdminScaffoldingTable'),
    AdminScaffoldingContextHolder = require('components/Commons/AdminScaffolding/AdminScaffoldingContextHolder'),
    FormGroupTextfield = require('components/Commons/BasicForm/FormGroupTextfield/FormGroupTextfield'),
    Authentication = require('services/Security').Authentication,
    ContentUtils = require('utils/ContentUtils'),
    InventoryStore = require('stores/InventoryStore'),
    NavigationUtils = require('utils/NavigationUtils'),
    {orderBy, map, filter} = require('lodash/collection'),
    Constants = require('constants/AppConstants'),
    get = require('lodash/object').get,
    CustomDialog = require('components/Commons/Dialog/CustomDialogHolder'),
    {Navigation} = require('react-router'),
    ga = require('react-ga');

const pageUrl = '/non-inventory-items';

let NonInventoryItemsAdmin = React.createClass({displayName: "NonInventoryItemsAdmin",
    mixins: [Authentication, AdminScaffoldingContextHolder, Navigation],

    getInitialState() {
        return {
            selectedItem: null,
            isEditMode: false,
            isFetching: true,
            filter: {
                code: '',
                description: '',
                category: '',
                subCategory: '',
                unit: '',
                salePrice: ''
            }
        };
    },

    componentDidMount() {
        this.fetchItems();
        ga.pageview('/non-items-admin');
    },

    fetchItems() {
        const self = this;
        InventoryStore.fetchNonInventoryItems(function (items) {
            const itemsSorted = ContentUtils.filterEnable(ContentUtils.sortList(items, 'description'));
            self.setState({
                items: self.filterVirtualSaleItems(itemsSorted),
                isFetching: false
            });
        });
    },

    fetchItemsBy(filter) {
        const self = this;
        InventoryStore.fetchItemsBy(filter, function (items) {
                const itemsSorted = ContentUtils.sortList(ContentUtils.filterEnable(items), 'description');
                self.setState({
                    items: self.filterVirtualSaleItems(itemsSorted),
                    isFetching: false
                });
        });
    },

    filterVirtualSaleItems(items) {
        return filter(items, item => get(item, 'category') !== Constants.SALE_VIRTUAL_ITEM_CATEGORY);
    },

    onDeleteItem(item, onSuccess, onFailure) {
        CustomDialog.showWarningConfirmation(
            t('warning'),
            t('non_inventory_warning_delete_items'),
            () => {
                InventoryStore.deleteItem(item, onSuccess, onFailure);
            }
        );
    },

    onChangeItem(item, onSuccess, onFailure) {
        item.category = Constants.ITEM_CATEGORY_NON_INVENTORY;
        InventoryStore.changeItem(item, onSuccess, onFailure);
    },

    onAddItem(item, onSuccess, onFailure) {
        item.category = Constants.ITEM_CATEGORY_NON_INVENTORY;
        InventoryStore.addItem(item, onSuccess, onFailure);
    },


    shouldNotAllowRepeatName(items, newItemName) {
        let itemNames = map(items, item => get(item, 'description')) || [];
        const currentItemDescription = get(this.state, 'selectedItem.description');

        if (currentItemDescription) {
            itemNames = filter(itemNames, itemName => itemName != currentItemDescription);
        }

        const alreadyExist = itemNames.indexOf(newItemName) > -1;

        return alreadyExist ? t('non_inventory_error_item_already_exist') : '';
    },

    _onTypingFilter(name, match) {
        if (!this.state.isFetching) {
            this.setState(prevState => {
                let nextFilter = prevState.filter || {};
                nextFilter[name] = match;
                this.fetchItemsBy(nextFilter);
                return {
                    filter: nextFilter,
                    isFetching: true
                };
            });
        }
    },

    _onCancel() {
        this.transitionTo(getCurrentUrl());
        this.setState({
            selectedItem: null,
            isEditMode: false,
            filter: {
                code: '',
                description: '',
                category: '',
                subCategory: '',
                unit: '',
                salePrice: ''
            }
        });
    },

    render() {
        if (!this.state.items) {
            return React.createElement(Loading, null);
        } else {
            const messages = {
                changeSuccessMessage: t('non_inventory_items_change_success'),
                changeFailureMessage: t('non_inventory_items_change_failure'),
                deleteSuccessMessage: t('non_inventory_items_delete_success'),
                addSuccessMessage: t('non_inventory_items_add_success'),
                addFailureMessage: t('non_inventory_items_add_failure')
            };
            let contextHolder = this.getContextHolderInstance();
            let {selectedItem, items, isEditMode, isFetching} = this.state;
            const secuancialOrder = ContentUtils.filterEnable(orderBy(items, 'description'));

            let formFieldsEl = [
                React.createElement(FormGroupTextfield, {
                    operationsHolder: contextHolder, 
                    readerAttribute: "description", 
                    isRelaxedText: true, 
                    name: t('non_inventory_column_item_description'), 
                    value: selectedItem, 
                    label: t('non_inventory_item_description'), 
                    isEditMode: isEditMode, 
                    additionalValidation: this.shouldNotAllowRepeatName.bind(this, secuancialOrder), 
                    onEnter: this.__onEnterPress}
                ),

                React.createElement(FormGroupTextfield, {
                    operationsHolder: contextHolder, 
                    readerAttribute: "unit", 
                    isRelaxedText: true, 
                    name: t('non_inventory_item_unit'), 
                    value: selectedItem, 
                    label: t('non_inventory_item_unit'), 
                    isEditMode: isEditMode, 
                    onEnter: this.__onEnterPress}
                ),

                React.createElement(FormGroupTextfield, {
                    operationsHolder: contextHolder, 
                    readerAttribute: "salePrice", 
                    isRelaxedText: true, 
                    name: t('non_inventory_item_price'), 
                    value: selectedItem, 
                    label: t('non_inventory_item_price'), 
                    isEditMode: isEditMode, 
                    onEnter: this.__onEnterPress}
                )
            ];


            return (
                React.createElement("div", {className: "brewhouse-view"}, 
                    React.createElement(AdminScaffolding, {
                        title: t('non_inventory_items_title'), 
                        moduleName: "ADMIN_ITEM", 
                        messages: messages, 
                        contextHolder: contextHolder, 
                        value: selectedItem, 
                        fetchItems: this.fetchItems, 
                        headerFields: formFieldsEl, 
                        onAdd: this.onAddItem, 
                        onChange: this.onChangeItem, 
                        onCancel: this._onCancel, 
                        onDelete: this.onDeleteItem, 
                        addEnterKeyDown: this.__addEnterKeyDown
                    }, 

                        React.createElement(AdminScaffoldingTable, {
                            headerActiveFilters: this.state.headerActiveFilters, 
                            onRowSelection: this.__onRowSelection, 
                            value: selectedItem, 
                            sortByColumn: ['description'], 
                            filteredColumns: [
                                'code',
                                'description',
                                'category',
                                'subCategory',
                                'unit',
                                'salePrice'
                            ], 
                            displayAttributes: [
                                'code',
                                'description',
                                'category',
                                'unit',
                                'salePrice'
                            ], 
                            columnNames: [
                                t('non_inventory_column_code'),
                                t('non_inventory_column_item_description'),
                                t('non_inventory_column_category'),
                                t('non_inventory_column_unit'),
                                t('non_inventory_column_price')
                            ], 
                            isLoading: isFetching, 
                            columnsFilterValue: this.state.filter, 
                            onCancel: this._onCancel, 
                            onTypingFilter: this._onTypingFilter
                        }, 
                            secuancialOrder
                        )
                    )
                )
            );
        }
    }
});

function getCurrentUrl() {
    return pageUrl + NavigationUtils.getPathParam('page');
}

module.exports = NonInventoryItemsAdmin;



/** WEBPACK FOOTER **
 ** ./src/views/ItemsAdmin/NonInventoryItemsAdmin.jsx
 **/